import { observer } from 'mobx-react-lite'
import { Platform, Pressable, StyleSheet, View } from 'react-native'

import { GameModalKinds } from '../../../models/game/game-modals'
import { palette } from '../../../theme/palette'
import {
  AllIn,
  AppPermission,
  BuyChip,
  GameDelete,
  JoinCall,
  ModalContentConfig,
  RemovedByTeacher,
  RoundWinner,
  ThreeCardLeaveConfirm,
  ThreeCardStart
} from './Content'
import { EndPracticeGame } from './Content/EndPracticeGame'

interface ModalContentProps {
  config?: ModalContentConfig
}

export const ModalContent = observer(({ config }: ModalContentProps) => {
  if (!config) return null
  const { dismissOnBackdrop, props } = config
  return (
    <View style={styles.layout}>
      {dismissOnBackdrop ? <Pressable style={styles.backdrop} onPress={props.onClose} /> : null}
      <View style={[styles.container, Platform.OS === 'web' ? { maxWidth: 500 } : {}]}>
        <Component config={config} />
      </View>
    </View>
  )
})

const Component = observer(({ config }: { config: ModalContentConfig }) => {
  const { kind, props } = config
  switch (kind) {
    // case GameModalKinds.handWinnersModal:
    //   return <RoundWinner {...props} />
    case GameModalKinds.allIn:
      return <AllIn {...props} />
    case GameModalKinds.options:
      return <JoinCall {...props} />
    case GameModalKinds.buy:
      return <BuyChip {...props} />
    case GameModalKinds.gameDeleted:
      return <GameDelete {...props} />
    case GameModalKinds.endPracticeGame:
      return <EndPracticeGame {...props} />
    case GameModalKinds.threeCardStart:
      return <ThreeCardStart {...props} />
    case GameModalKinds.threeCardLeaveConfirm:
      return <ThreeCardLeaveConfirm {...props} />
    case GameModalKinds.appPermission:
      return <AppPermission {...props} />
    case GameModalKinds.removedByTeacher:
      return <RemovedByTeacher {...props} />
  }
})

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.blackWithOpacity.twenty
  },
  container: {
    backgroundColor: palette.cream,
    borderRadius: 12,
    width: '80%',
    display: 'flex',
    justifyContent: 'center'
  },
  backdrop: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%'
  }
})
